import { Component, OnInit } from '@angular/core';
import {  FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiCallService } from "src/app/api/service/api-call.service";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { ValidationService } from "src/app/services/validation.service";
import { environment } from "src/environments/environment";
import * as Constants from "../../../../../constant/Constants";

@Component({
  selector: 'app-page4',
  templateUrl: './page4.component.html',
  styleUrls: ['./page4.component.css']
})
export class Page4Component implements OnInit {
  // Url Params
  claim: string = 'own';  // own, flood, fire ... etc.
  id: string = "none";
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };
  

  pageHeading: string = 'Claim Form';
  pageHeadingSuffix: string = ' Claim Form (Continued)';
  pageSubheading: string = 'Enter Independent Witness Details';

  witnessNameLabel: string = 'Enter name of witness (optional)';
  witnessTelLabel: string = 'Enter the witness\' phone number  (optional)';
  addWitnessLabel: string = 'Add another witness';

  passengerDetailsSubheading: string = 'Passenger Details';
  passengerNameLabel: string = 'Enter name of passenger  (optional)';
  passengerTelLabel: string = 'Enter the passenger\'s phone number (optional)';
  addPassengerLabel: string = 'Add another passenger';

  courtesyCarSubheading: string = 'Courtesy Car';
  regionLabel: string = 'Select your Region';

  fullNameLabel: string = 'Your Full Name';
  dateLabel: string = 'Date';

  iSwearText: string = 'I hereby declare that these particulars are true, and undertake to forward immediately (if any, unanswered), correspondence relating to this accident.';

  cancelText: string = 'Cancel';
  saveText: string = 'Save and Continue';

  requiredString: string = 'This field is required';
  remove: string = 'Remove';

  minDate: Date;
  maxDate: Date;

  namePlaceHolder: string = '';

  motorForm = this._formBuilder.group({
    witnesses: this._formBuilder.array([
      this.createWitnessesFormGroup()
    ]),
    passengers: this._formBuilder.array([
      this.createPassengerFormGroup()
    ]),

    // region: [''],

    fullName: ['', [Validators.required, Validators.pattern(/^.+ .+/)]],
    date: [moment(), Validators.required],

    driverWarning: [''],
    iSwear: [false],
  })
  formErrors:{[key:string]:string} ={
    witnessName:'',
    witnessTel:'',
    passengerName:'',
    passengerTel:'',
    // region:'',
    fullName:'',
    date:'',
    driverWarning:'',
  }
  validationMessages:{[key:string]:{[key:string]:string}} ={
    witnessName: { pattern: 'Please enter the Full Name' },
    witnessTel: {required: this.requiredString },
    passengerName: { pattern: 'Please enter the Full Name' },
    passengerTel: {required: this.requiredString },
    // region: {required: this.requiredString },
    fullName: {required: this.requiredString, pattern: 'Please enter your Full Name' },
    date: {required: this.requiredString },
    driverWarning: {required: this.requiredString },
  }

  url: string = environment.baseUrl + Constants.claimExtraDetailsURL;
  loading: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private validationService: ValidationService,
    public dialog: MatDialog,
    private apiCallService: ApiCallService ) { 
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 1)

    this.minDate = tempDate;
    this.maxDate = currentDate;
  }

  ngOnInit(): void {
    this.motorForm.valueChanges.subscribe((form)=>{
      this.logErrors();

      if (form.fullName) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          fullName: form.fullName.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      const witnessDetails = this.motorForm.get('witnesses') as FormArray;

      witnessDetails.controls.forEach(control => {
        const witnessName = control.get('witnessName');
        if (!(witnessName === null || witnessName.value === '')) {
          control.patchValue({
            witnessName: witnessName.value.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match: string) => match.toUpperCase())
          }, {emitEvent: false});
        }
        const witnessTel = control.get('witnessTel');
        if (!(witnessTel === null || witnessTel.value === '')) {
          control.patchValue({
            witnessTel: witnessTel.value.replace(/[a-z]/g, (match: string) => match.toUpperCase())
          }, {emitEvent: false});
        }
      })

      const passengerDetails = this.motorForm.get('passengers') as FormArray;
      passengerDetails.controls.forEach(control => {
        const passengerName = control.get('passengerName');
        if (!(passengerName === null || passengerName.value === '')) {
          control.patchValue({
            passengerName: passengerName.value.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match: string) => match.toUpperCase())
          }, {emitEvent: false});
        }
        const passengerTel = control.get('passengerTel');
        if (!(passengerTel === null || passengerTel.value === '')) {
          control.patchValue({
            passengerTel: passengerTel.value.replace(/[a-z]/g, (match: string) => match.toUpperCase())
          }, {emitEvent: false});
        }
      })
    });

    this.route.queryParams.subscribe(params => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;
      
      if (params["id"] !== undefined) {
        this.id = params["id"];

        this.getPolicyDetails();
      }

      if (params['claim'] !== undefined) {
        this.claim = params['claim'];

        if (params['claim'] === 'fire') {
          this.pageHeading = 'Fire Damage' + this.pageHeadingSuffix;

        } else if (params['claim'] === 'flood') {
          this.pageHeading = 'Flood Damage' + this.pageHeadingSuffix;

        } else if (params['claim'] === 'own') {
          this.pageHeading = 'Own Damage/Car Damage' + this.pageHeadingSuffix;
          
        }
      }

    });
  }

  createWitnessesFormGroup(): FormGroup {
    return this._formBuilder.group({
      witnessName: [''],
      witnessTel: [''],
    });
  };

  createPassengerFormGroup(): FormGroup {
    return this._formBuilder.group({
      passengerName: [''],
      passengerTel: [''],
    });
  };

  addNewWitness() {
    const fields = this.motorForm.get('witnesses') as FormArray;
    fields.push(this.createWitnessesFormGroup());
    this.motorForm.setControl('witnesses', fields);
  }

  addNewPassenger() {
    const fields = this.motorForm.get('passengers') as FormArray;
    fields.push(this.createPassengerFormGroup());
    this.motorForm.setControl('passengers', fields);
  }

  removeWitness(i:number) {
    const fields = this.motorForm.get('witnesses') as FormArray;
    fields.removeAt(i);  
  }

  removePassenger(i:number) {
    const fields = this.motorForm.get('passengers') as FormArray;
    fields.removeAt(i);  
  }

  getWitnesses() : FormArray {  
    return this.motorForm.get("witnesses") as FormArray  
  }

  getPassengers() : FormArray {  
    return this.motorForm.get("passengers") as FormArray  
  }

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages,
      true
    );
  }

  async getPolicyDetails() {
    try {
      const dat = {
        id: this.id
      };
      const response = await this.apiCallService.postRequest(
        environment.baseUrl + Constants.policyDetailsURL, dat);

      if (response.error) {
        console.log(':Get details ERROR :: ', response);
      } else {
        this.namePlaceHolder = response.body.name;
        this.motorForm.get('fullName')?.setValue(this.namePlaceHolder);
      }
    } catch (error) {
      console.log(':Details ERROR !! :: ', error);
    }
  }

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      page: 'claimData4',
      witnesses: this.motorForm.controls["witnesses"].value,
      passengers: this.motorForm.controls["passengers"].value,
      // region: this.motorForm.controls["region"].value,
      fullName: this.motorForm.controls["fullName"].value,
      date: this.motorForm.controls["date"].value,
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }

}
